export const LOGO_IMG = 'assets/images/logo.png';
export const CANCEL_IMG = 'assets/images/cancel.png';
export const COINS_IMG = 'assets/images/auth/coins.svg';
